<div *ngIf="!loginDisplay">
    <h1 class="welcome">Welcome to the new BC-Connect-App!</h1>
    <h2>Please sign-in</h2>
</div>

<div *ngIf="loginDisplay">
    <p>Login successful!</p>
    <p>Request your profile information by clicking Profile above.</p>
</div>
